
/**
 * This map represents drift-specific query params that the widget will use to perform certain actions on load
 *
 * ONESHOT_TOKEN - Informs the widget that the load was referred via a Drift email or an email integration (such as Outreach)
 *
 * FALLBACK_CONVERSATION - Informs the widget that the load was referred via a Drift fallback email and should continue the provided conversation
 */
export default {
  ONESHOT_TOKEN: 'd_utk',
  FALLBACK_CONVERSATION: 'd_conversation'
}
